import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import Button from '../common/Button';
import Card from '../common/Card';

export default function GateManagement({ escolaId }) {
    const [gates, setGates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newName, setNewName] = useState('');
    const [adding, setAdding] = useState(false);

    useEffect(() => {
        if (escolaId) loadGates();
    }, [escolaId]);

    const loadGates = async () => {
        try {
            setLoading(true);
            const { data, error } = await supabase
                .from('portoes')
                .select('*')
                .eq('escola_id', escolaId)
                .order('nome');
            if (error) throw error;
            setGates(data || []);
        } catch (error) {
            console.error('Erro ao carregar portões:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;

        try {
            setAdding(true);
            const { error } = await supabase
                .from('portoes')
                .insert([{ nome: newName.trim(), escola_id: escolaId }]);
            if (error) throw error;
            setNewName('');
            loadGates();
        } catch (error) {
            console.error('Erro ao adicionar portão:', error);
            alert('Erro ao adicionar portão.');
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (id) => {
        if (!confirm('Deseja realmente excluir este portão? Alunos vinculados a ele ficarão sem portão definido.')) return;
        try {
            const { error } = await supabase
                .from('portoes')
                .delete()
                .eq('id', id);
            if (error) throw error;
            loadGates();
        } catch (error) {
            console.error('Erro ao deletar portão:', error);
            alert('Não é possível deletar portões que possuem alunos ou monitores vinculados.');
        }
    };

    return (
        <div className="space-y-6">
            <Card className="border-2 border-primary/10">
                <form onSubmit={handleAdd} className="flex gap-3">
                    <input
                        type="text"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                        placeholder="Nome do novo portão (Ex: Portão B)"
                        className="flex-1 px-4 py-3 bg-gray-50 border-2 border-transparent focus:border-primary rounded-2xl font-bold transition-all"
                        required
                    />
                    <Button variant="primary" type="submit" loading={adding} className="rounded-2xl">
                        + Criar Portão
                    </Button>
                </form>
            </Card>

            {loading ? (
                <div className="text-center py-10">Carregando portões...</div>
            ) : (
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {gates.map(gate => (
                        <Card key={gate.id} className="flex items-center justify-between group hover:border-primary/30 transition-all p-4">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center text-lg">
                                    🚪
                                </div>
                                <span className="font-bold text-gray-700">{gate.nome}</span>
                            </div>
                            <button
                                onClick={() => handleDelete(gate.id)}
                                className="text-gray-300 hover:text-red-500 transition-colors"
                            >
                                ✕
                            </button>
                        </Card>
                    ))}
                    {gates.length === 0 && (
                        <div className="col-span-full py-10 text-center text-gray-400 font-medium">
                            Nenhum portão cadastrado. Crie o primeiro acima!
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
